import Vue from 'vue'

import { debounce } from 'lodash'

import { Services, getServicePathToAPI, joinURLPath } from '@sigma-frontend-libs/commons'
import { NOTIFICATIONS_AVAILABLE_TYPES } from '@sigma-legacy-libs/essentials/lib/constants'
import { NotificationCurrentChannelsEnum, OrderDirections } from '@sigmasms/shared-types'

import { generateServices, getSocket, globalErrorHandler, request } from '@/utils'

import { getColor } from '@/components/services/notifications/utils'

import render from './render'

const pathToAPI = getServicePathToAPI(Services.notifications)

export default {
  name: 'Widget',

  mixins: [
    generateServices({
      name: Services.notifications,

      backendGeneration: 'nest',

      find: {
        defaultFilter: {
          targetUserId: undefined,
          channel: NotificationCurrentChannelsEnum.web
        },
        defaultPagination: { limit: 10 },
        defaultOrder: { [`${Services.notifications}.createdAt`]: OrderDirections.DESC }
      },

      get: false,
      create: false,
      remove: false
    })
  ],

  props: {
    show: Boolean
  },

  data() {
    return {
      arrow: {
        top: false,
        bottom: false
      },

      loading: {}
    }
  },

  watch: {
    'account.id'(value) {
      if (value) {
        this.rest[Services.notifications].find({ targetUserId: value })
      }
    },

    show(value) {
      if (value) {
        this.$nextTick(() => {
          this.wheelHandler()
        })
      }
    }
  },

  mounted() {
    const socket = getSocket()
    this.rest[Services.notifications].find({ targetUserId: this.account.id })

    socket?.on(`${Services.notifications}.sent`, notification => {
      if (notification.channel === NOTIFICATIONS_AVAILABLE_TYPES.web) {
        if (Array.isArray(this.restData[Services.notifications].find.data)) {
          this.restData[Services.notifications].find.data.splice(0, 0, notification)
          if (this.restData[Services.notifications].find.data.length > this.restData[Services.notifications].find.pagination.limit) {
            this.restData[Services.notifications].find.data.pop()
          }
          this.$emit('getNotification')
          this.addSnackbar({
            text: this.getTranslate(`${Services.notifications}.events.${notification.type}`),
            type: getColor.call(this, notification.type)
          })
        }
      }
    })

    socket?.on(`${Services.notifications}.read`, notification => {
      const index = this.restData[Services.notifications].find.data.findIndex(item => {
        return item.id === notification.id
      })
      if (index !== -1) {
        this.restData[Services.notifications].find.data.splice(index, 1, {
          ...this.restData[Services.notifications].find.data[index],
          ...notification
        })
      }
    })

    this.$nextTick(() => {
      this.scrollHandler()
      this.scroll('top')
    })
  },

  methods: {
    read: debounce(
      async function(id) {
        try {
          const { isRead, targetUserId } = this.restData[Services.notifications].find.data.find(item => {
            return item.id === id
          }) ?? {}
          if (targetUserId === this.account.id) {
            if (!isRead) {
              Vue.set(this.loading, id, true)
              const data = await request.patch(joinURLPath(pathToAPI, id, 'read'))
              const index = this.restData[Services.notifications].find.data.findIndex(item => {
                return item.id === data.id
              })
              if (index !== -1) {
                this.restData[Services.notifications].find.data.splice(index, 1, {
                  ...this.restData[Services.notifications].find.data[index],
                  ...data
                })
              }
            }
          }
        } catch (error) {
          globalErrorHandler(error)
        } finally {
          Vue.set(this.loading, id, false)
        }
      },
      100,
      {
        leading: true,
        trailing: true
      }
    ),

    scroll(direction) {
      const { viewport, list } = this.$refs
      if (!viewport || !list) {
        return
      }
      let scrollAmount = list.clientHeight
      if (direction === 'top') {
        scrollAmount = -list.clientHeight
      }
      viewport.scrollTo({
        top: scrollAmount,
        behavior: 'smooth'
      })
    },

    async wheelHandler() {
      if (this.show) {
        const { viewport, list } = this.$refs
        if (!viewport || !list || !list.children) {
          return
        }

        const ids = new Set()
        const viewportRect = viewport.getBoundingClientRect()
        for (const child of list.children) {
          const id = child.getAttribute('id')
          const childRect = child.getBoundingClientRect()
          if (childRect.top < viewportRect.top || childRect.bottom > viewportRect.bottom) {
            continue
          } else {
            if (id) {
              ids.add(id)
            }
          }
        }

        await Promise.allSettled(Array.from(ids).map(id => {
          return this.read(id)
        }))
      }
    },
    scrollHandler() {
      const { viewport, list } = this.$refs
      if (viewport && list && list.children) {
        this.arrow.top = viewport.scrollTop > list.children[0].clientHeight
        this.arrow.bottom = viewport.scrollTop + viewport.clientHeight < viewport.scrollHeight - 100
      }
    }
  },

  render
}
